import Api from '../../../services/api'

export default {
  data() {
    return {
      updateMode: false,
    }
  },
  methods: {
    update() {
      console.log(this.item);
      Api.registration.update(this.item)
        .then((response) => {
          console.log(response);
          this.$emit('registration-updated');
        });
    },
    updateRegistration(registrationId) {
      this.updateMode = true;
      this.loading = true;
      Api.registration.get(registrationId)
        .then((response) => {
          this.item = response.data;
          this.refreshAllAddress();

          // this.provinces.push(this.item.province);
          this.cities = [this.item.city];
          this.barangays = [this.item.barangay];

          // this.birthProvinces.push(this.item.province);
          this.birthCities = [this.item.birthCity];
        })
        .finally(() => { this.loading = false; });
    }
  }
}